import type { ExperimentUser } from '@amplitude/experiment-js-client';

import type { UserSession } from '@/api/client';

/**
 * Maps an authenticated session to {@link ExperimentUser} for remote evaluation.
 * Sets `surface_admin: true` on {@link ExperimentUser.user_properties} when `user.is_admin`
 * so Amplitude Experiment targeting matches cohorts without relying on Analytics-only sync.
 * Targeting uses session email, tenant, and admin status.
 */
export const createExperimentUserFromSession = (
  user?: UserSession | null
): ExperimentUser => {
  if (!user) {
    return {};
  }

  const user_properties: Record<string, string | boolean> = {
    email: user.email,
    saas_tenant_id: String(user.saas_tenant_id),
  };

  if (user.is_admin === true) {
    user_properties.surface_admin = true;
  }

  return {
    user_id: user.id,
    user_properties,
  };
};
